// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__8kMul {
  padding: 16px; }

.styles_form__sFZ-J {
  display: flex;
  flex-direction: column;
  gap: 16px; }

.styles_buttonGroup__izjC8 {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px; }
`, "",{"version":3,"sources":["webpack://./src/modules/teachings/components/TeachingForm/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB,EAAA","sourcesContent":[".container {\n  padding: 16px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.buttonGroup {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__8kMul`,
	"form": `styles_form__sFZ-J`,
	"buttonGroup": `styles_buttonGroup__izjC8`
};
export default ___CSS_LOADER_EXPORT___;
